import { render, staticRenderFns } from "./ProjectSprints.vue?vue&type=template&id=1a7024c6&scoped=true"
import script from "./ProjectSprints.vue?vue&type=script&lang=js"
export * from "./ProjectSprints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7024c6",
  null
  
)

export default component.exports